import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue2TouchEvents from 'vue2-touch-events'
import globalConfig from './../../../globalConfig'

Vue.config.productionTip = false

Vue.use(Vue2TouchEvents)

if (process.env.NODE_ENV === 'development')
  window.PE_CLIENTAPP_ID = globalConfig.staging.testClientAppIds.trivia

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#puzzleapp')
